import { debounce } from 'acast-www-utils';
import compare from './compare';
import Operation from './operation';

const QueueByEntity = {};

export default class Queue {
  static forEntity(id, schemaName) {
    const key = `${schemaName}-${id}`;
    if (!(key in QueueByEntity)) {
      QueueByEntity[key] = new Queue(key);
    }
    return QueueByEntity[key];
  }

  static clearAll() {
    Object.keys(QueueByEntity).forEach(key => delete QueueByEntity[key]);
  }

  constructor(id) {
    this.id = id;
    this.transactions = [];
    this.pending = null;
    this.timeout = null;
  }

  append(transaction) {
    const current = this.transactions;
    const filtered = current.filter(tx => tx.type === transaction.type);
    const final = filtered.reduce((tx, next) => tx.merge(next), transaction);

    this.transactions = current.filter(tx => tx.type !== final.type).concat(final);

    final.commit();

    if (transaction.type === Operation.UPDATE) {
      this.schedule();
    } else {
      this.next();
    }

    return final;
  }

  commit(transaction) {
    transaction.commit();

    if (this.pending === null) {
      const index = this.transactions.indexOf(transaction);

      if (index > -1) {
        this.transactions.splice(index, 1);
      }

      this.pending = transaction;

      transaction
        .run()
        .then(response => this.complete(transaction, response.value))
        .catch(error => {
          transaction.fail(error);
          this.rollback(transaction);
        });
    }

    return transaction;
  }

  complete(transaction, res = {}) {
    const response = Array.isArray(res) ? res[0] : res;
    transaction.complete(response);
    this.pending = null;
    const diff = compare.deep(transaction.entity, response);
    if (diff.length > -1) {
      const current = this.transactions;
      const filtered = current.filter(tx => tx.type === transaction.type);
      const next = filtered[0];

      /**
       * If we have another operation of the same type queued up, we will
       * prepend the reponse to it so that we do not lose any potential server
       * updates, however if this was the last operation then we will simply
       * append the reponse to the local state and commit to the application
       * state.
       */
      if (next) {
        next.prepend(response);
      } else {
        transaction.appendToLocalState(response).commit();
      }
    }
    this.schedule();
  }

  schedule = debounce(500, () => {
    this.next();
  });

  rollback() {
    /**
     * There is currently no rollback logic and is still something we need to
     * figure out exactly how to handle. The client error handling will be
     * handled in the resource controller as it will receive the error there.
     */
    this.pending = null;
  }

  next() {
    this.pending = null;

    if (this.transactions.length) {
      const first = this.transactions.splice(0, 1)[0];
      this.commit(first);
    }
  }
}
